// 對應 CustomizeModel.FormType的列舉
export class ActionType {
  static get Login () {
    return 1
  }
  static get Add () {
    return 2
  }
  static get Update () {
    return 3
  }
  static get Delete () {
    return 4
  }
  static get Import () {
    return 5
  }
  static get Work () {
    return 6
  }
  static get UploadPhoto () {
    return 7
  }
  static get DeletePhoto () {
    return 8
  }
  static get Revoke () {
    return 9
  }
  static get Track () {
    return 10
  }
  static get Acceptance () {
    return 11
  }
  static get Throw () {
    return 12
  }
  static get Review () {
    return 13
  }
  static get Export () {
    return 14
  }
  static get Sign () {
    return 15
  }
  static get UploadPDF () {
    return 16
  }
  static get DownloadPDF () {
    return 17
  }
  static get Copy () {
    return 18
  }
  static get Invalid () {
    return 19
  }
  static get Merge () {
    return 20
  }
  static get Accept () {
    return 21
  }
  static get Reject () {
    return 22
  }
  static get Done () {
    return 23
  }
  static get Cancel () {
    return 24
  }
  static get NotInvalid () {
    return 25
  }

  static ActionTypeName (actionType) {
    let tmpType = parseInt(actionType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '登入'
        break
      case 2:
        name = '新增'
        break
      case 3:
        name = '修改'
        break
      case 4:
        name = '刪除'
        break
      case 5:
        name = '匯入'
        break
      case 6:
        name = '派工'
        break
      case 7:
        name = '上傳圖片'
        break
      case 8:
        name = '刪除圖片'
        break
      case 9:
        name = '收回'
        break
      case 10:
        name = '追蹤'
        break
      case 11:
        name = '驗收'
        break
      case 12:
        name = '轉拋'
        break
      case 13:
        name = '簽核'
        break
      case 14:
        name = '匯出'
        break
      case 15:
        name = '回簽'
        break
      case 16:
        name = '上傳PDF'
        break
      case 17:
        name = '下載PDF'
        break
      case 18:
        name = '複製'
        break
      case 19:
        name = '作廢'
        break
      case 20:
        name = '合併'
        break
      case 21:
        name = '接受'
        break
      case 22:
        name = '拒絕'
        break
      case 23:
        name = '完工'
        break
      case 24:
        name = '取消'
        break
      case 25:
        name = '反作廢'
        break
    }
    return name
  }
}
